module.exports = __webpack_public_path__ + "img/erys-2.c1013564.jpg";